export const serviceDmpToDmp = (dmp) => {
    // Handle different formats of updated_at
    let updatedAt;
    if (typeof dmp.updated_at === "string") {
        // If it's a string (ISO format), parse it
        updatedAt = new Date(dmp.updated_at);
    }
    else if (dmp.updated_at && "seconds" in dmp.updated_at) {
        // If it's the standard seconds timestamp format
        updatedAt = new Date(dmp.updated_at.seconds * 1000);
    }
    else {
        // Fallback to epoch date if format is unknown
        updatedAt = new Date(0);
    }
    return {
        code: dmp.code,
        id: dmp.id,
        name: dmp.name,
        status: dmp.status,
        parent: dmp.parent ? dmp.parent : undefined,
        audienceLinkEnabled: dmp.audience_link_enabled,
        updatedAt
    };
};
//# sourceMappingURL=index.js.map